import React, { useMemo } from 'react';

import { useSettings } from '../../hooks/useSettings';
import { ProjectTreeAlias } from './component/projectsTreeAlias';
import { useProjectTreeItems } from './hook/useProjectTreeItems';

const { Layout, Column, ProjectCell, Cell } = ProjectTreeAlias;

export const ProjectsTree: React.FC = () => {
    const { itemsList, mappingItemIdIndex } = useProjectTreeItems();

    const { saveUserProjectSettings, userSettingsInitialRef } = useSettings();

    return useMemo(() => {
        const saveWbsSize = (projectId: string, size: number) => {
            const userSettings = userSettingsInitialRef.current ?? {};
            const projectsSettings = userSettings.project ?? {};
            const projectSettings = projectsSettings[projectId] ?? {};
            projectSettings.gantWbsColumnSize = size;
            projectsSettings[projectId] = projectSettings;
            userSettings.project = projectsSettings;

            userSettingsInitialRef.current = userSettings;

            saveUserProjectSettings(projectId, {
                gantWbsColumnSize: size,
            });
        };

        return (
            <Layout
                data={itemsList}
                mappingItemIdIndex={mappingItemIdIndex}
                renderProject={(project) => <ProjectCell project={project} />}
                renderProjectChildren={(tree, project) => (
                    <>
                        <Column
                            minWidth={30}
                            tree={tree}
                            isSizable={true}
                            width={userSettingsInitialRef.current?.project?.[project.item.id]?.gantWbsColumnSize}
                            dataKey={'numberWBS'}
                            render={(value, record) => <Cell dragType="between" value={value} record={record} />}
                            onResizeEnd={(sizes) => {
                                saveWbsSize(project.item.id, sizes);
                            }}
                        />
                        <Column
                            flex={1}
                            tree={tree}
                            dataKey={'name'}
                            render={(value, record) => (
                                <Cell dragType="parent" value={value} record={record} isLastColumn hasCollapseControl />
                            )}
                        />
                    </>
                )}
            />
        );
    }, [itemsList]);
};
